"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayableProperties = void 0; // @internal

exports.displayableProperties = {
  menuBarIcon: {
    description: 'Name of the file used as icon for the MenuBar',
    type: 'string',
    nullable: true
  }
};